import DispositionExplainer from './DispositionExplainer'

export { DispositionExplainer }
export default DispositionExplainer
